Core.Dashboard = {
    init: function () {
        Core.Dashboard.Cache = {
        	$rowToggle : $('.dashboard__grid--body .dashboard__grid--row-info'),
        	$headTick : $('.dashboard__grid--heading-cell-tick input[type=checkbox]'),
        	$btnDropMore: $('.btn-more-actions'),
        	$dropLink: $('.drop-list-link'),
        	$btnToggle: $('.btn-toggle'),
            $btnView: $('.btn-view')
        }

    	this.contentToggle();
    	this.dropToggle();
    	this.PreventDropLink();
    	this.viewDetail();
    	this.setupPopup();
    },

    contentToggle: function () {
        var reset = function (doReset, $detail, $info) {
            var $allInfo = $('.dashboard__grid--body .dashboard__grid--row-info')
                , $allDetail = $('.dashboard__grid--body .dashboard__grid--row-detail');

            $allDetail.addClass('content-hide');
            $allInfo.removeClass('showing-detail');

            if (doReset) {
                $detail.addClass('content-hide');
                $info.removeClass('showing-detail');
            } else {
                $detail.removeClass('content-hide');
                $info.addClass('showing-detail');
            }
        };

        Core.Dashboard.Cache.$btnToggle.on('click', function (e) {
    		var $el = $(this)
    		    , $row = $el.closest('.dashboard__grid--row-info')
                , $info = $row.next('.dashboard__grid--row-detail');

    		if ($info.is(':visible')) {
    		    reset(true, $info, $row);
            }
    		else {
    		    reset(false, $info, $row);
            }

        });
    },

    dropToggle: function(){
    	Core.Dashboard.Cache.$btnDropMore.on('click', function(e){
    		e.stopPropagation();
    		var $siblingDrop = $(this).siblings('.drop-content');

    		$siblingDrop.addClass('exc');
    		$('.drop-content:not(.exc)').removeClass('show');
    		$siblingDrop.removeClass('exc').toggleClass('show');
    	});
    },

    PreventDropLink: function() {
    	Core.Dashboard.Cache.$dropLink.on('click', function(e){
    		e.preventDefault();
    		$(this).closest('.drop-content').removeClass('show');
    	});
    },

    viewDetail: function () {
        Core.Dashboard.Cache.$btnView.on('click', function (e) {
            e.preventDefault();
            console.log('view detail');
        });
    },

    setupPopup: function () {

        Core.InitPopup($('#popupCancelOrder'), 'Cancel Order');
        Core.InitPopup($('#popupResubmitOrder'), 'Resubmit Order');
        Core.InitPopup($('#popupEditDraftOrder'), 'Edit Draft Order');
        Core.InitPopup($('#popupReturnCartOrder'), 'Edit And Return Cart');
        Core.InitPopup($('#popupChangeApproveOrder'), 'Change And Approve Order');

        var closePopup = function ($el) {
            $el.close();
        };

        var openPopup = function ($el) {
            $el.center().open();
        };

        var initPopup = function ($el) {
            return $el.kendoWindow({
                maxWidth: 580,
                minWidth: 450,
                visible: false,
                iframe: false,
                modal: true,
                resizable: false,
                pinned: true,
                draggable: false,
                animation: false,
                appendTo: '#page-wrap'
            });
        };


        var setPopup = function ($el, title) {
            if($el.length){
                var $kw = $el.data("kendoWindow");
                $kw.wrapper.addClass("popup-dashboard");
                $kw.title(title);
                return $kw;
            } else {
                return false;
            }
        };

        var $popupDetail = $('#popupDetail');
        var $popupReject = $('#popupReject');
        //var $popupCancel = $('#popupCancelOrder');

        $popupDetail = initPopup($popupDetail);
        $popupReject = initPopup($popupReject);
        //$popupCancel = initPopup($popupCancel);

        var $kPopDetail = setPopup($popupDetail, "View Detail");
        var $kPopReject = setPopup($popupReject, "Rejection Reason");
        //var $kPopReject = setPopup($popupCancel, "Cancel Order");

        $('.btn-view').on('click', function (e) {
            e.preventDefault();
            Core.Dashboard.preparePopupDetail($popupDetail, $(this).closest('.dashboard__grid--row'));
            openPopup($kPopDetail);
        });

        $('.btn-reject').on('click', function (e) {
            e.preventDefault();
            openPopup($kPopReject);
        });

        $(".k-overlay").on('click', function (e) {
            e.preventDefault();
            closePopup($kPopDetail);
        });

        $('.btn-popup-cancel').on('click', function () {
            closePopup($kPopReject);
        });


    },

    preparePopupDetail: function ($popupDetail, $row) {
        var popupPrf = ".popup__body-";
        var rowPrf = ".dashboard__grid--body-cell-";
        var properties = ["client", "order", "therapist"];

        $.each(properties, function (i, prop) {
            var propVal = $row.find(rowPrf + prop + ' .dashboard__grid--value').text().replace(/\s/g, '');
            $popupDetail.find(popupPrf + prop).html(propVal);
        });
    }
}
